import React from "react";
import Header from "../menu/Header";
import Menu from "../menu/Menu";
import { useEffect, useState, useContext } from "react";
import { adminContext } from "../../../context/admincontext";
import { GetAllAdminReports } from "../../../services/adminServices";
import Pagination from "../../Pagination/Pagination";
const Reports = () => {
  const [list, setList] = useState([]);
  const [page, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [selected, setSelected] = useState({});
  const { setPage } = useContext(adminContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setPage("گزارشات");
        const { data } = await GetAllAdminReports(10, page);
        console.log(data);
        setList(data.result);
        setTotalPage(data.totalPage);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [page]);

  return (
    <div style={{ paddingTop: "10px" }}>
      <Header />
      <div className="d-flex content-box">
        <Menu />
        <div className="w-100 me-lg-3 ms-lg-5 px-2 py-4 reports-box">
          {list.map((i, index) => (
            <div className="reports-item-box p-2 mb-4" key={index}>
              <div className="px-2 reports-item-header">
                <p className="mb-0">{i.title}</p>
                <p className="mb-0">کارشناس مربوطه : "{i.Ex_Expert.name}"</p>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <p style={{ textAlign: "right" }}>
                  {i.content.substring(0, 100)}...
                </p>
                <button
                  className="btn"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  onClick={() => {
                    setSelected(i);
                  }}
                  style={{
                    width: "200px",
                    backgroundColor: "#6BBA81",
                    borderRadius: "20px",
                  }}
                >
                  مشاهده جزییات
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Pagination
        setPageNumber={setPageNumber}
        page={page}
        totalPage={totalPage}
      />

      <div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content text-end">
            {selected.content && (
              <div className="modal-body">
                <strong>جزییات گزارش</strong>
                <hr />
                <p>کارشناس: {selected.Ex_Expert.name}</p>
                <p>
                  شماره صورت :{" "}
                  {selected.Ex_Sheet.requestToken &&
                    selected.Ex_Sheet.requestToken}
                </p>
                <p>
                  تاریخ :{" "}
                  {selected.createdAt &&
                    new Intl.DateTimeFormat("fa-IR").format(
                      new Date(selected.createdAt)
                    )}
                </p>
                <p className="text-end">{selected.content}</p>
              </div>
            )}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
